export const getInspectorDisplayName = (inspection, vendors, enumerations) => {
  if (!vendors || !inspection) return null;
  const type = inspection?.inspectionTypeId ?? '00000000-0000-0000-0000-000000000000';
  let typeTitle =
    enumerations && Array.isArray(enumerations.inspectionTypes) ? enumerations.inspectionTypes.find(s => s.id === type)?.title : '';
  const vendor = vendors.find(v => v.vendorId === inspection?.vendorId);
  return `${typeTitle} (${vendor?.companyName})`;
};
